module.exports = __webpack_public_path__ + "static/img/teenpatt_th.04b3d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/teenpatt_th.png
// module id = bbUI
// module chunks = 1